import React from 'react'
import { Formik, Form } from 'formik'
import { Button, Container, Grid, TextField } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { getErrorProps } from '../utils'
import { useStore } from '../Store'
import { useToaster } from './Toaster';
import useOnlineStatus from '../hooks/useOnlineStatus';
import Logo from './Logo'
import Header from './Header';

const Register = ({ history }) => {
    const isOnline = useOnlineStatus()
    const { showError, showMessage } = useToaster()
    const { register } = useStore()

    const initialValues = {
        username: "",
        password: "",
        password2: "",
        email: "",
        firstname: "",
        lastname: "",
        suffix: ""
    }

    const validate = (values) => {
        const errors = {}
        if (!values.lastname) {
            errors.lastname = 'vul uw achternaam in';
        }
        if (!values.username) {
            errors.username = 'vul uw gebruikersnaam in';
        }
        if (!values.password) {
            errors.password = 'vul uw wachtwoord in';
        }
        if (!values.password2) {
            errors.password2 = 'vul controle wachtwoord in';
        }
        if (values.password !== values.password2) {
            errors.password2 = 'controle wachtwoord komt niet overeen';
        }
        if (!values.email) {
            errors.email = 'vul uw email in';
        }
        if (!values.email2) {
            errors.email2 = 'vul controle email in';
        }
        if (values.email !== values.email2) {
            errors.email2 = 'controle email komt niet overeen';
        }
        return errors
    }

    const submit = async (formik) => {
        const values = formik.values
        formik.validateForm(values)
        if (!formik.isValid) {
            showError('Een of meerdere gegevens ontbreken')
            return
        }
        if (!isOnline) {
            showError('Geen verbinding met de server')
            return
        }

        try {
            await register({
                username: values.username,
                password: values.password,
                email: values.email,
                firstname: values.firstname,
                lastname: values.lastname,
                suffix: values.suffix
            })
            showMessage('U ontvangt een e-mail op het door u opgegeven adres waarmee u de registratie kunt voltooien.')
            history.push("/login")
        } catch (error) {
            showError(error)
        }
    }

    return (
        <Header backAction={() => history.push('/login')} title="Registreren">
            <Formik
                initialValues={initialValues}
                validate={validate}
            >
                {(formik) => (
                    <Container>
                        <Grid
                            container
                            justify="center"
                            alignItems="center">
                            <Form>
                                <Grid container>
                                <Alert severity="info">
            Vul de velden in en klik op 'registreren'. U ontvang dan een e-mailbericht op het opgegeven e-mailadres met een link waarmee u de registratie kunt voltooien
            </Alert>
                                    <Grid item xs={12} style={{ textAlign: 'center' }} >
                                        <h1>Registeren</h1>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="voornaam" variant="standard" fullWidth
                                            {...formik.getFieldProps("firstname")}
                                            {...getErrorProps(formik, "firstname")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="tussenvoegsel" variant="standard" fullWidth
                                            {...formik.getFieldProps("suffix")}
                                            {...getErrorProps(formik, "suffix")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="achternaam" variant="standard" fullWidth required
                                            {...formik.getFieldProps("lastname")}
                                            {...getErrorProps(formik, "lastname")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="gebruikersnaam" variant="standard" fullWidth required
                                            autoComplete="off" 
                                            {...formik.getFieldProps("username")}
                                            {...getErrorProps(formik, "username")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="wachtwoord" variant="standard" type="password" fullWidth required
                                            autoComplete="off"
                                            {...formik.getFieldProps("password")}
                                            {...getErrorProps(formik, "password")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="controle wachtwoord" variant="standard" type="password" fullWidth required
                                            autoComplete="off"
                                            {...formik.getFieldProps("password2")}
                                            {...getErrorProps(formik, "password2")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="e-mail adres" variant="standard" fullWidth required
                                            {...formik.getFieldProps("email")}
                                            {...getErrorProps(formik, "email")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="controle e-mail adres" variant="standard" fullWidth required
                                            {...formik.getFieldProps("email2")}
                                            {...getErrorProps(formik, "email2")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button disabled={!formik.isValid} variant="contained" onClick={() => submit(formik)} color="primary" fullWidth>Registreren</Button>
                                    </Grid>
                                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                                        <Logo />
                                    </Grid>
                                </Grid>
                            </Form>
                        </Grid>
                    </Container>
                )}
            </Formik>
        </Header>
    )
}

export default Register
